jQuery(($) => {

    if ($('.m-thumbnail-cta-cards--is-slider')[0]) {
        $('.m-thumbnail-cta-cards--is-slider .m-thumbnail-cta-cards__list').slick({
            slidesToShow: 3,
            infinite: false,
            swipe: true,
            swipeToSlide: true,
            appendArrows:'.m-thumbnail-cta-cards--is-slider .js-arrow-navigation',
            dots: true,
            appendDots: '.m-thumbnail-cta-cards--is-slider .js-dot-navigation',
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        });
    } 
    
     if ($('.m-thumbnail-cta-cards--is-grid')[0]) {
        $(window).on('load resize', function () {
            if ($(window).width() > 768) {
                if ($('.m-thumbnail-cta-cards--is-grid .m-thumbnail-cta-cards__list').hasClass('slick-initialized')) {
                    $('.m-thumbnail-cta-cards--is-grid .m-thumbnail-cta-cards__list').slick('unslick');
                }
            } else if (!$('.m-thumbnail-cta-cards--is-grid .m-thumbnail-cta-cards__list').hasClass('slick-initialized')) {
                $('.m-thumbnail-cta-cards--is-grid .m-thumbnail-cta-cards__list').slick({
                    slidesToShow: 1,
                    infinite: false,
                    swipe: true,
                    swipeToSlide: true,
                    appendArrows: '.m-thumbnail-cta-cards--is-grid .js-arrow-navigation',
                    dots: true, 
                    appendDots: '.m-thumbnail-cta-cards--is-grid .js-dot-navigation'
                });
            } 
        });
     }

     if ($('.m-thumbnail-cta-cards--is-small-grid')[0]) {
        $(window).on('load resize', function () {
            if ($(window).width() > 768) {
                if ($('.m-thumbnail-cta-cards--is-small-grid .m-thumbnail-cta-cards__list').hasClass('slick-initialized')) {
                    $('.m-thumbnail-cta-cards--is-small-grid .m-thumbnail-cta-cards__list').slick('unslick');
                }
            } else if (!$('.m-thumbnail-cta-cards--is-small-grid .m-thumbnail-cta-cards__list').hasClass('slick-initialized')) {
                $('.m-thumbnail-cta-cards--is-small-grid .m-thumbnail-cta-cards__list').slick({
                    slidesToShow: 1,
                    infinite: false,
                    swipe: true,
                    swipeToSlide: true,
                    appendArrows: '.m-thumbnail-cta-cards--is-small-grid .js-arrow-navigation',
                    dots: true, 
                    appendDots: '.m-thumbnail-cta-cards--is-small-grid .js-dot-navigation'
                });
            } 
        });
     }
 });